const OutsourcedStatusEnum = {
  Collected: 'Collected',
  FeeAttached: 'FeeAttached',
  ReadyForInvoicing: 'ReadyForInvoicing',
  ApprovedForInvoicing: 'ApprovedForInvoicing',
  Invoiced: 'Invoiced',
  Uninvoiceable: 'Uninvoiceable',
};

export default OutsourcedStatusEnum;
